const logging = require('../../helpers/log')('MediaProcessorConnector');

class MediaProcessorConnector {
  constructor(connector) {
    this.connector = connector;
  }

  setTrack = async (track) => {
    let filteredTrack = null;

    try {
      filteredTrack = await this.connector.setTrack(track);
      this.originalTrack = track;
    } catch (err) {
      logging.error(`Error setting video track: ${err}`);
    }

    return filteredTrack;
  };

  destroy = async () => {
    try {
      await this.connector.destroy();
    } catch (err) {
      logging.warn(`Error destroying connector: ${err}`);
    }
    if (this.originalTrack) {
      this.originalTrack.stop();
      this.originalTrack = null;
    }
  };

  static isValidConnector = connector => typeof connector?.setTrack === 'function'
    && typeof connector?.destroy === 'function';
}

module.exports = MediaProcessorConnector;
